<div class="modal-wrapper">
  <div mat-dialog-title class="modal-title">
    <h2>{{ "ONSIP_I18N.TRANSFER_NUMBERS" | translate }}</h2>
  </div>
  <div mat-dialog-content>
    <div class="mat-body-1">{{ "ONSIP_I18N.CHOOSE_DESTINATION_PBX" | translate }}</div>
    <mat-form-field appearance="outline" class="form-control" tabindex="-1">
      <mat-select [formControl]="formControl">
        @for (pbx of pbxList; track pbx) {
        <mat-option [value]="pbx">
          {{ pbx?.domain }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="description">
      {{
        "ONSIP_I18N.ONCE_NUMBERS_ARE_TRANSFERRED_REMEMBER_TO_UPDATE_THEIR_DESTINATIONS_ON_THE_PHONE_NUMBERS_PAGE_FOR"
          | translate
      }}
      ‘{{ formControl.value?.domain }}’
    </div>
  </div>
  <div mat-dialog-actions class="button-container modal-actions">
    <button mat-button color="primary" type="button" (click)="dialogRef.close()">
      {{ "ONSIP_I18N.CANCEL" | translate }}
    </button>
    <button mat-flat-button color="primary" type="button" (click)="submitData()">
      {{ "ONSIP_I18N.TRANSFER" | translate | titlecase }}
    </button>
  </div>
</div>
